export { default as Img200 } from './processed/200/bravesmash.jpg';
export { default as Img400 } from './processed/400/bravesmash.jpg';
export { default as Imgthumb } from './processed/thumb/bravesmash.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/bravesmash.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/bravesmash.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      193,
      51,
      63
    ],
    "_population": 108,
    "_hsl": [
      0.9859154929577465,
      0.5819672131147542,
      0.4784313725490196
    ]
  },
  "LightVibrant": {
    "_rgb": [
      103,
      190,
      240
    ],
    "_population": 400,
    "_hsl": [
      0.5608272506082725,
      0.8203592814371257,
      0.6725490196078432
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      12,
      52,
      124
    ],
    "_population": 2,
    "_hsl": [
      0.6071428571428571,
      0.8235294117647058,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      96,
      97,
      160
    ],
    "_population": 84,
    "_hsl": [
      0.6640625,
      0.25196850393700787,
      0.5019607843137255
    ]
  },
  "LightMuted": {
    "_rgb": [
      185,
      138,
      163
    ],
    "_population": 126,
    "_hsl": [
      0.9113475177304965,
      0.251336898395722,
      0.6333333333333333
    ]
  },
  "DarkMuted": {
    "_rgb": [
      84,
      58,
      56
    ],
    "_population": 524,
    "_hsl": [
      0.011904761904761904,
      0.19999999999999998,
      0.27450980392156865
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/bravesmash.js